module.exports = __webpack_public_path__ + "static/Transnet_Logo_2013-facc41dde9239a0efc16cb1f68b62c54.svg";